import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

const SwitchDetailedLabel = (props) => {
    const {
        disabled = false,
        value = false,
        labels = ['Off', 'On'],
        colors = { off: 'error', on: 'secondary' }, // fixed palette mapping
        onChange = () => null,
        name = null,
        sx = {},
        typographySx = {},
        size = 'medium'
    } = props;

    return (
        <Stack className="pr-2" direction="row" alignItems="center">
            <Typography
                className="fw-bold"
                color={colors.off}
                variant="subtitle1"
                sx={{
                    fontSize: { xs: 7, md: 10 },
                    ...typographySx,
                }}
            >
                {labels[0]}
            </Typography>

            <Switch
                disabled={disabled}
                checked={value}
                onChange={onChange}
                name={name}
                size={size}
                sx={{
                    '& .MuiSwitch-track': {
                    backgroundColor: (theme) => theme.palette[colors.off].main,
                    opacity: 1,
                    },

                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: (theme) => theme.palette[colors.on].main,
                    opacity: 1,
                    },

                    '& .MuiSwitch-thumb': {
                    color: (theme) =>
                        value ? theme.palette[colors.on].main : theme.palette[colors.off].main,
                    },

                    ...sx,
                }}
            />


            <Typography
                className="fw-bold"
                color={colors.on}
                variant="subtitle1"
                sx={{
                    fontSize: { xs: 7, md: 10 },
                    ...typographySx,
                }}
            >
                {labels[1]}
            </Typography>
        </Stack>
    );
};

export default SwitchDetailedLabel;
